<div class="activities-tab-container flex-col h-full">
  @if (!isLoading() && !hasError() && activities().length > 0) {
    <div
      class="activity-filters"
      role="group"
      aria-label="Filtrar atividade">
      @for (option of filters; track option.value) {
        <button
          type="button"
          class="activity-filter"
          [class.activity-filter--active]="filter() === option.value"
          [attr.aria-pressed]="filter() === option.value"
          [disabled]="filterCounts()[option.value] === 0"
          (click)="setFilter(option.value)">
          {{ option.label }}
          <span class="activity-filter-count">{{ filterCounts()[option.value] }}</span>
        </button>
      }
    </div>
  }
  <div class="activities-list flex-col flex-1">
    @if (isLoading()) {
      <div class="skeleton-activities-list flex-col gap-16 p-16">
        <div class="skeleton skeleton-date-separator"></div>

        @for (item of [1, 2, 3]; track item) {
          <div class="skeleton-activity flex-row gap-12">
            <div class="timeline-indicator-skeleton">
               <div class="skeleton-dot"></div>
               <div class="skeleton-line"></div>
            </div>
            <div class="skeleton-activity-body flex-col gap-8">
              <div class="flex-row items-center gap-8">
                 <div class="skeleton skeleton-avatar-circle"></div>
                 <div class="skeleton skeleton-text" style="width: 40%"></div>
              </div>
              <div class="skeleton skeleton-text" style="width: 80%"></div>
            </div>
          </div>
        }
      </div>
    } @else if (hasError()) {
      <div class="empty-state">
        <aionz-empty-content
          title="Erro ao carregar atividades"
          description="Não foi possível buscar as atividades da solicitação. Tente recarregar a página."
          icon="error_outline">
        </aionz-empty-content>
      </div>
    } @else if (activities().length === 0) {
      <div class="empty-state">
        <aionz-empty-content
          title="Nenhuma atividade"
          description="Esta solicitação ainda não possui atividades."
          icon="history">
        </aionz-empty-content>
      </div>
    } @else if (filteredActivities().length === 0) {
      <div class="empty-state">
        <aionz-empty-content
          title="Nenhuma atividade neste filtro"
          description="Escolha outro filtro para ver os demais eventos."
          icon="filter_list_off">
        </aionz-empty-content>
      </div>
    } @else {
      @for (group of groupedActivities(); track group.dateLabel) {
        <div class="date-separator">
          <span class="date-separator-label">{{ group.dateLabel }}</span>
        </div>

        <div class="timeline-group">
          @for (view of group.activities; track view.activity.id) {
            @let activity = view.activity;
            @let type = view.type;
            <div class="timeline-item flex-row gap-12">
              <div class="timeline-indicator flex-col items-center">
                <span
                  class="timeline-icon"
                  [class]="'timeline-icon timeline-icon--' + type.tone"
                  aria-hidden="true">
                  <mat-icon>{{ type.icon }}</mat-icon>
                </span>
                <div class="timeline-line"></div>
              </div>
              <div class="timeline-content flex-col gap-4">
                <div class="timeline-header flex-row items-center justify-between gap-12">
                  <span class="timeline-title text-truncate">{{ type.title }}</span>
                  <span class="time">{{ formatTime(activity.createdAt) }}</span>
                </div>
                <div class="timeline-author flex-row items-center gap-6">
                  <seed-user-avatar [size]="18" [src]="activity.author.avatarUrl"></seed-user-avatar>
                  <span class="author-name text-truncate" [title]="activity.author.name">{{ activity.author.name }}</span>
                </div>
                <div class="timeline-message">
                  @for (segment of view.segments; track $index) {
                    @if (segment.kind === 'text') {
                      <span>{{ segment.text }}</span>
                    } @else {
                      <span
                        class="activity-chip"
                        [class]="'activity-chip activity-chip--' + segment.chip"
                        [title]="segment.hint || segment.label">
                        <mat-icon aria-hidden="true">{{ chipIcons[segment.chip] }}</mat-icon>
                        <span class="activity-chip-label">{{ segment.label }}</span>
                      </span>
                    }
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
